var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtomoPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1111 22.2222H22.2222V31.1111H17.7778V22.2222H8.88889V17.7778H17.7778V8.88889H22.2222V17.7778H31.1111V22.2222ZM35.5556 0H4.44444C1.97778 0 0 1.97778 0 4.44444V35.5556C0 36.7343 0.468252 37.8648 1.30175 38.6983C2.13524 39.5317 3.2657 40 4.44444 40H35.5556C36.7343 40 37.8648 39.5317 38.6983 38.6983C39.5317 37.8648 40 36.7343 40 35.5556V4.44444C40 1.97778 38 0 35.5556 0Z",
    fill: "#F0572D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtomoPlus);
export default __webpack_public_path__ + "static/media/atomoPlus.d13c54cb6185c41fd9f1b69dc8a18435.svg";
export { ForwardRef as ReactComponent };